import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { setNestedObjectValues } from "formik";
import cn from "classnames";

import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import PhoneField from "components/InputsField/formikInputs/PhoneField";
import Button from "components/common/Button";
import { sendAim } from "helpers/statisticAim";

import styles from "./styles.module.scss";
import { ERROR_PLACE } from 'components/InputsField/InputError';

const UserForm = ({ setFieldTouched, validateForm, setTouched, setFormStep }) => {
    const { t } = useTranslation();

    const [passVisible, setPassVisible] = useState(false);
    const [rePassVisible, setRePassVisible] = useState(false);

    const handlePassVisible = () => {
        setPassVisible(!passVisible);
    };
    const handleRePassVisible = () => {
        setRePassVisible(!rePassVisible);
    };
    const handleUserRigistration = async () => {
        const validationErrors = await validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setTouched(setNestedObjectValues(validationErrors, true));
        } else {
            sendAim("reg_step1");
            setFormStep(2);
        }
    };

    return (
        <>
            <FormikTextField
                name="firstname"
                maxLength="32"
                label={t("registration.firstname")}
                wrapperClassName={styles["field--with-margin"]}
                required
                errorMode={ERROR_PLACE.static}
            />
            <FormikTextField
                name="lastname"
                maxLength="32"
                label={t("registration.lastname")}
                wrapperClassName={styles["field--with-margin"]}
                required
                errorMode={ERROR_PLACE.static}
            />
            <PhoneField
                wrapperClass={styles["field--with-margin"]}
                specialLabel=""
                onTouch={setFieldTouched}
                label={t("registration.phone")}
                name="phone"
                required
                errorMode={ERROR_PLACE.static}
            />
            <FormikTextField
                name="email"
                maxLength="32"
                label={t("registration.email")}
                wrapperClassName={styles["field--with-margin"]}
                autoComplete="email"
                required
                errorMode={ERROR_PLACE.static}
            />
            <FormikTextField
                name="password"
                type={passVisible ? "text" : "password"}
                maxLength="64"
                label={t("registration.password")}
                wrapperClassName={styles["field--with-margin"]}
                autoComplete="new-password"
                additionalComponent={
                    <button
                        type="button"
                        className={cn(styles.eye, passVisible && styles["eye--hide"])}
                        onClick={handlePassVisible}
                    />
                }
                required
                errorMode={ERROR_PLACE.static}
            />
            <FormikTextField
                name="rePassword"
                type={rePassVisible ? "text" : "password"}
                maxLength="64"
                label={t("registration.repeat_password")}
                wrapperClassName={styles["field--with-margin"]}
                autoComplete="new-password"
                additionalComponent={
                    <button
                        type="button"
                        className={cn(styles.eye, rePassVisible && styles["eye--hide"])}
                        onClick={handleRePassVisible}
                    />
                }
                required
                errorMode={ERROR_PLACE.static}
            />
            <div className={styles.button}>
                <Button type="button" onClick={handleUserRigistration}>
                    {t("registration.continue_button")}
                </Button>
            </div>
        </>
    );
};

export default UserForm;
